import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { oldGloryBaseUrl } from 'config/apiConfig';
import { MERCHANT_TYPE } from 'types/sendAndRequest';
import { getDefaultCompanyId } from 'utils/helpers';

interface SendMoneyActivityTypes {
    amount: number;
    confirmationCode: string;
    currencyCode: string;
    transactionDateTime: string;
    transactionStatus: 'COMPLETED' | 'PENDING' | 'FAILED';
    transactionSubtype: string;
    transactionType: string;
    type: string;
}

interface typesOfSendMoney {
    sendMoneyRecords: SendMoneyActivityTypes[];
    totalRecords: number;
    loading: boolean;
    error: string | null;
}
const initialState: typesOfSendMoney = {
    sendMoneyRecords: [],
    totalRecords: 0,
    loading: false,
    error: null,
};
export interface SendMoneyPayload {
    nickname: string;
    amount: number | null;
    subject?: string;
    fromSva: number | null;
    senderIsBusiness?: boolean;
    receiverIsBusiness?: boolean;
    status?: string;
    type?: string;
}

export const sendMoney = createAsyncThunk(
    'sendMoney/requestSendMoeny',
    async ({ payload, type }: { payload: SendMoneyPayload; type?: string }) => {
        const endPoint = type === MERCHANT_TYPE ? '/transfer/transferM2m' : '/transfer/transferM2p';
        const response: any = await client.post(`${oldGloryBaseUrl}${endPoint}`, payload);
        return response;
    }
);

export const getRecentFrequentUsers = createAsyncThunk('sendMoney/getRecentFrequentUsers', async (_, { getState }) => {
    const state: any = getState();
    const companyId = getDefaultCompanyId(state);

    const response: any = await client.get(`${oldGloryBaseUrl}/user/getRecentFrequentUsers`, {
        headers: {
            companyId,
        },
    });
    return response;
});

export const fetchSendMoneyActivityList = createAsyncThunk('sendMoneyList/fetchSendMoneyList', async (_, { getState }) => {
    const state: any = getState();
    const companyId = getDefaultCompanyId(state);
    const { offset, pageSize } = state?.app?.table || {};
    const response: any = await client.get(`${oldGloryBaseUrl}/account/history`, {
        headers: {
            companyId,
            offset,
            pageSize,
        },
    });
    return response?.trxHistories;
});

const sendMoneyActivitySlice = createSlice({
    name: 'sendMoneyList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchSendMoneyActivityList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchSendMoneyActivityList.fulfilled, (state, action) => {
            state.loading = false;
            if (!action?.payload) return;
            state.sendMoneyRecords = action?.payload || [];
        });
        builder.addCase(fetchSendMoneyActivityList.rejected, (state) => {
            state.loading = false;
        });
    },
});

export default sendMoneyActivitySlice.reducer;
